import { useEffect, useRef, useState } from 'react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
import { fetchConsentAssetDataUrl, fetchConsentTemplateJson } from './consent_template_library_fetch';
import { consentElementsToPreviewOverlays } from '../bundler';
/** Fetches CONSENT_TEMPLATE JSON first, then the CONSENT_ASSET blob for read-only preview. */
export const useConsentTemplateSourcePreview = (documentId) => {
    const [state, setState] = useState({ status: 'loading' });
    const { get } = useApiClient(ApiClientService.LIBRARY);
    const getRef = useRef(get);
    getRef.current = get;
    useEffect(() => {
        if (!documentId) {
            return;
        }
        let cancelled = false;
        setState({ status: 'loading' });
        (async () => {
            try {
                const template = await fetchConsentTemplateJson(getRef.current, documentId);
                const meta = (template.metadata ?? {});
                const data = (template.data ?? {});
                const assetId = meta.consentAssetId;
                const elements = data.elements ?? [];
                const roles = data.roles ?? [];
                const templatePackageId = data.templatePackageId ?? '';
                if (!assetId) {
                    if (!cancelled) {
                        setState({ status: 'error', message: 'No CONSENT_ASSET linked to this template.' });
                    }
                    return;
                }
                const pdfDataUrl = await fetchConsentAssetDataUrl(getRef.current, assetId);
                if (!cancelled) {
                    setState({
                        status: 'ready',
                        pdfDataUrl,
                        overlays: consentElementsToPreviewOverlays(elements, roles),
                        title: template.name,
                        templatePackageId,
                    });
                }
            }
            catch (e) {
                if (!cancelled) {
                    setState({ status: 'error', message: e instanceof Error ? e.message : 'Failed to load preview.' });
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [documentId]);
    return state;
};
